import axios from 'axios';

export default {

  getOptions (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/options`);
  },

  createOption (projectId, option, createNegation = false) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/options?createNegation=${createNegation}`, option);
  },

  updateOption (projectId, option) {
    return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/options/${option.id}`, option);
  },

  deleteOption (projectId, optionId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/options/${optionId}`);
  },

  createConflictingOptions (projectId, conflictingOptions) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/complements`, conflictingOptions);
  },

  getAllConflictingOptions (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/complements`);
  },

  deleteConflictingOption (projectId, complementId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/complements/${complementId}`);
  },

  inlineOptions(options) {
    return options
      .map(opt => opt.id)
      .sort()
      .join(',');
  },

  copy(option) {
    // remove conflictionOptions property to avoid circular dependency on jsonification
    let {conflictingOptions, ...opt} = option;
    conflictingOptions; // avoid lint non-used-var
    return JSON.parse(JSON.stringify(opt));
  },

};